import { AxiosPromise } from 'axios';
import { queryTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';

import { HymotscLookupDataType } from 'src/types/services/common-service.type';
import { axiosc } from 'src/app/utils';

export const hymotscCommonLookup = <T>({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load = undefined,
  urlRoute = '',
}: HymotscLookupDataType): AxiosPromise<T> => {
  const query: queryTypes.HymotscLookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (value === undefined && limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  if (load) {
    query.load = load.join(',');
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlRoute), {
    blockSpinner,
  });
};
